import { createRequestData, searchRequestData } from '../../Utility/apiHelper';
import { requestHideLoader, requestShowLoader } from '../Global/action';
import * as actionType from './type';

export const requestCreateCustomer = (payload, onSuccess, onError) => async (dispatch) => {
    dispatch(requestShowLoader());
    const url = `${process.env.REACT_APP_BASE_URL}customers`;
    const response = await createRequestData(payload, url);
    dispatch(requestHideLoader());
    if (response?.status === 200 || response?.status === 201) {
        if (onSuccess) onSuccess(response?.data);
    } else {
        if (onError && response?.propererror?.status !== 401) {
            onError(response?.propererror);
        }
    }
};


export const requestGetAllCustomers = (queryparams) => async(dispatch) => {
    try {
        dispatch({
            type: actionType?.REQUEST_GET_ALL_CUSTOMERS
        })
        const customerSearchUrl = `${process.env.REACT_APP_BASE_URL}customers`;
        const responsedata = await searchRequestData(queryparams , customerSearchUrl , false)
        dispatch({
            type: actionType.RECEIVED_GET_ALL_CUSTOMERS,
            payload: responsedata?.data
        })
    } catch(error) {
        dispatch(requestHideLoader())
    }
}

export const requestGetCustomersPaged = (queryparams) => async (dispatch) => {
    dispatch({ type: actionType.REQUEST_GET_PAGED_CUSTOMERS })
    dispatch(requestShowLoader())
    try {
        const customersPagedUrl = `${process.env.REACT_APP_BASE_URL}customers/paged`;
        const responsedata = await searchRequestData(queryparams, customersPagedUrl, false)
        dispatch({
            type: actionType.RECEIVED_PAGED_CUSTOMERS,
            payload: responsedata?.data
        })
    } catch (error) {
    }
    dispatch(requestHideLoader())
}